const Urls = {
	Api: {
		terms: function( product_id ) {
			return '/my/api/2/product/' + product_id + '/lease-terms';
		},
		term: '/my/api/2/shopping-cart/active/leasing',
		content_blocks: '/crm/json/global/content_blocks/get.aspx'
	},
	Templates: {
		app: '/my/api/2/templates?name=modules/product-lease/app.html',
		help: '/my/api/2/templates?name=modules/product-lease/help.html'
	}
};

export default Urls;